/**
 * Copyright (c) 2026
 * Barrel export for all shadcn hooks.
 * This file is auto-maintained — re-export new hooks here after adding them via the shadcn CLI.
 */
export { useIsMobile } from './use-mobile'
